import '../assets/scss/index.scss'

import '../assets/js/nav-btn.js'
import '../assets/js/cursor.js'
import '../assets/js/filter-modal.js'
import '../assets/js/filter-works.js'
import '../assets/js/about-section-triggers.js'
import '../assets/js/screenLock.js'